import { PaccVideoDetailResultDto, PaccVideoResultRs } from '@domain/rs/phs/pacc/results/PaccVideoResultRs';
import { VideoType } from '@domain/constant/videoType';
import { VideoQuestionType } from '@domain/constant/videoQuestionType';

export class PaccVideoDetailResultVO {
  type: VideoType;
  url: string;
  videoErrorYn: boolean; // 개별 영상 영상 오류 여부
  voiceErrorYn: boolean; // 개별 영상 음성 오류 여부
  questionType: VideoQuestionType; // 질문 종류
  questionNum: number; // 질문 단위
  question: string; // 개별 영상 질문 내용

  constructor(rs: PaccVideoDetailResultDto) {
    this.type = rs.type;
    this.url = rs.url;
    this.videoErrorYn = rs.videoErrorYn;
    this.voiceErrorYn = rs.voiceErrorYn;
    this.questionType = rs.questionType;
    this.questionNum = rs.questionNum;
    this.question = rs.question;
  }
}

export class PaccVideoResultVO {
  unreliableYn: boolean;
  comment: string;
  details: PaccVideoDetailResultVO[] | null;

  constructor(rs: PaccVideoResultRs) {
    this.unreliableYn = rs.unreliableYn;
    this.comment = rs.comment;
    this.details = rs.details?.map((detail) => new PaccVideoDetailResultVO(detail));
  }
}
